import React, { useState, useEffect } from "react";
import { NavLink, Route } from "react-router-dom";

import axios from "axios";
import { server } from "../utills/utils";

import { connect } from "react-redux";
import * as actionTypes from "../store/actions/actionTypes";

import styled from "styled-components";

import Navigation from "../components/Navigations/MainNavigation";
import ShopMenu from "../components/ShopView/ShopMenu";
import ShopReviews from "../components/ShopView/ShopReviews";
import Footer from "../components/Footer";
import AddedModal from "../components/Modals/NotifyModal";
import Spinner from "../components/Modals/SpinnerModal";
import ProductViewModal from "../components/Modals/ProductViewModal";
import ProductView from "../components/ShopView/ProductView";
import ReactImageFallback from "react-image-fallback";

import Image from "../assets/cover.jpg";

const ShopContainer = styled.div`
  width: 80%;
  margin-left: 10%;
  padding: 60px 0;
  min-height: 100vh;
  @media (max-width: 768px) {
    width: 90%;
    margin-left: 5%;
  }
`;
const ShopProfile = styled.div`
  width: 100%;
  height: 200px;
`;
const ShopProfileContainer = styled.div`
  width: 100%;
  height: 350px;
  padding: 5% 0 2% 0;
  @media (max-width: 768px) {
    height: 100px;
  }
`;
const ShopProfileImage = styled.div`
  width: 30%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
  float: left;
  text-align: center;
  @media (max-width: 768px) {
    width: 27%;
  }
`;
const ProfilePicContainer = styled.img`
   {
    width: 110px;
    height: 110px;
    border-radius: 100%;
    border: 1px solid #ccc;
  }
`;
const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  border-radous: 5px;
`;
const ShopProfileIntro = styled.div`
  width: 68%;
  height: 100%;
  float: right;
  background: gray;
  @media (max-width: 768px) {
    width: 69%;
  }
`;
const ShopName = styled.h2`
  font-size: 2em;
  margin: 0;
  padding: 0;
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;
const ShopLocation = styled.h4`
  font-size: 1.2em;
  margin: 0;
  padding: 1% 0;
  font-weight: 400;
`;
const BusinessHour = styled.p`
  font-size: 1em;
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: gray;
`;
const ShopNav = styled.div`
  width: 100%;
  height: 40px;
  border-bottom: 3px solid #ccc;
`;
const NavItem = styled(NavLink)`
  color: gray;
  font-weight: 500;
  padding: 0 10px 0 0;
  font-size: 20px;
  text-decoration: none;
`;
const ShopBody = styled.div`
  width: 100%;
  height: auto;
  margin-top: 15px;
`;
const FavButton = styled.button`
  padding: 10px 20px;
  background: none;
  border: 1px solid #276fb7;
  color: #276fb7;
  border-radius: 5px;
  margin: 10px 0;
  cursor: pointer;
`;
const FavActiveButton = styled.button`
  padding: 10px 20px;
  background: #276fb7;
  border: 1px solid #276fb7;
  color: white;
  border-radius: 5px;
  margin: 10px 0;
  cursor: pointer;
`;
const Alert = styled.p`
  color: red;
  padding: 0;
  margin: 0;
`;
let productView;
function ShopView(props) {
  const [shop, setShop] = useState({});
  const [products, setProducts] = useState([]);
  const [complete, setComplete] = useState(false);
  const [shopComplete, setShopComplete] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);
  const [activeCat, setActiveCat] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [customers, setCustomers] = useState([]);
  const [loadProducts, setLoadProducts] = useState(false);
  const [alert, setAlert] = useState("");
  const [showProduct, setShowProduct] = useState(false);
  const [productId, setProductId] = useState("");
  const [productIndex, setProductIndex] = useState(null);

  //Single product view modal
  const showProductHandler = (id, productId) => {
    try {
      console.log("Product", id);
      setProductId(id);
      setProductIndex(productId);

      setShowProduct(!showProduct);
    } catch (error) {
      console.log(error);
    }
  };

  //onchage search text event

  const searchTextHandler = (text) => {
    setSearchText(text);
  };

  //add product to cart
  const addToCartHandler = (id) => {
    //debugger;
    if (localStorage.cart) {
      const get = JSON.parse(localStorage.getItem("cart") || "[]");
      const cart = get;
      console.log(id);
      const cartItem = {
        itemId: products[id]._id,
        quantity: 1,
        price: products[id].price,
        image: products[id].product.images[0],
        name: products[id].name,
      };
      console.log(cartItem);
      cart.push(cartItem);
      localStorage.setItem("cart", JSON.stringify(cart));
      props.setCart(cart);
      // this.setState({
      //   cartItems: cart,
      //   modalShow: false,
      // });
      // console.log(this.state.cartItems);
    } else {
      const cart = [];
      console.log(id);
      const cartItem = {
        itemId: products[id]._id,
        quantity: 1,
        price: products[id].price,
        image: products[id].product.images[0],
        name: products[id].name,
      };
      console.log(cartItem);

      cart.push(cartItem);
      localStorage.setItem("cart", JSON.stringify(cart));
      props.setCart(cart);
      // this.setState({
      //   cartItems: cart,
      //   modalShow: false,
      // });
      // console.log(this.state.cartItems);
    }
    setAdded(true);
    setShowProduct(false);
    setTimeout(() => setAdded(false), 1000);
  };

  const searchProducts = async (searchText) => {
    try {
      setLoadProducts(false);
      const products = await axios.post(server, {
        query: `
                      query{
                        searchShopProducts(shopId:"${shop._id}", searchText:"${searchText}"){
                                _id
                                name
                                price
                                product{
                                _id
                                name
                                brandName
                                brandId
                                name
                                price
                                measurment
                                images
                                
                                }
                              }
                          }
                        `,
      });
      console.log("Products", products);
      setProducts(products.data.data.searchShopProducts);
      setLoadProducts(true);
    } catch (error) {
      throw error;
    }
  };
  const filterProducts = async (catId) => {
    try {
      setLoadProducts(false);
      setActiveCat(catId);
      const products = await axios.post(server, {
        query: `
                      query{
                        filterShopProducts(shopId:"${props.match.params.shopId}", catId:"${catId}"){
                                _id
                                name
                                price
                                product{
                                _id
                                name
                                brandName
                                brandId
                                name
                                price
                                measurment
                                images
                                
                                }
                              }
                          }
                        `,
      });
      console.log("Products", products);
      setProducts(products.data.data.filterShopProducts);
      setLoadProducts(true);
    } catch (error) {
      throw error;
    }
  };
  const fetchProducts = async () => {
    try {
      setLoadProducts(false);
      const products = await axios.post(server, {
        query: `
                      query{
                              shopProducts(shopId:"${props.match.params.shopId}"){
                                _id
                                name
                                price
                                product{
                                _id
                                name
                                brandName
                                brandId
                                name
                                price
                                measurment
                                images
                                
                                }
                              }
                          }
                        `,
      });
      console.log("Products", products);
      setProducts(products.data.data.shopProducts);
      setComplete(true);
      setLoadProducts(true);
    } catch (error) {
      throw error;
    }
  };
  const Allfilter = () => {
    setActiveCat(null);
    fetchProducts();
  };

  const addFavourite = async () => {
    try {
      if (localStorage.TOKEN) {
        let new_customers = customers;
        new_customers.push(props.userId);
        setCustomers(new_customers);
        console.log(customers);
        await axios.post(server, {
          query: `
                      mutation{
                        addFavouriteShop(shop:"${shop._id}", user:"${props.userId}"){
                                _id

                              }
                          }
                        `,
        });
        const shopFav = await axios.post(server, {
          query: `
                query{
                  shopByUserName(shopId:"${props.match.params.shopId}"){
                    _id
                    name
                    cityName
                    thanaName
                    phone
                    userName
                    categories{
                      _id
                      name
                      categoryId
                      quantity
                    }
                    customers
                    coverImage
                  }
                }
              `,
        });
        console.log(shopFav);
        setShop(shopFav.data.data.shopByUserName);
        setCustomers(shopFav.data.data.shopByUserName.customers);
      } else {
        setAlert("please signin to add favourite shop!");
      }
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.viewedShop !== props.match.params.shopId) {
      localStorage.removeItem("cart");
      props.setCart([]);
    }
    const fetchShop = async (args, req) => {
      const shop = await axios.post(server, {
        query: `
                query{
                  shopByUserName(shopId:"${props.match.params.shopId}"){
                    _id
                    name
                    bio
                    location
                    phone
                    coverImage
                    profileImage
                    deliveryCharge
                    cityName
                    thanaName
                    userName
                    categories{
                      _id
                      name
                      categoryId
                      quantity
                    }
                    customers
                  }
                }
              `,
      });
      setShop(shop.data.data.shopByUserName);
      props.setViewedShop(shop.data.data.shopByUserName);
      localStorage.setItem(
        "delivery_charge",
        shop.data.data.shopByUserName.deliveryCharge
      );
      setCustomers(shop.data.data.shopByUserName.customers);

      if (localStorage.cart) {
        if (localStorage.shop) {
          if (localStorage.shop !== shop.data.data.shopByUserName._id) {
            localStorage.removeItem("cart");
          } else {
            const cart = JSON.parse(localStorage.getItem("cart") || "[]");
            // this.setState({
            //   cartItems: cart,
            // });
            props.setCart(cart);
          }
        }
      }
      localStorage.setItem("viewedShop", shop.data.data.shopByUserName._id);
      localStorage.setItem(
        "viewedShopname",
        shop.data.data.shopByUserName.name
      );

      setShopComplete(true);
    };
    fetchShop();
    // if (shopComplete) {
    fetchProducts();
    //}
  }, []);

  let button;
  customers.includes(props.userId)
    ? (button = <FavActiveButton>Favourited</FavActiveButton>)
    : (button = <FavButton onClick={addFavourite}>Favourite</FavButton>);
  console.log("VV shop", props.shop);
  return (
    <div>
      {/* {console.log("User id", props.userId)} */}
      <ProductViewModal show={showProduct} closeModal={showProductHandler}>
        {productId != "" ? (
          <ProductView
            addToCartHandler={addToCartHandler}
            closeModal={showProductHandler}
            id={productId}
            productId={productIndex}
          />
        ) : null}
      </ProductViewModal>
      <Navigation />
      {complete && shopComplete ? (
        <ShopContainer>
          <AddedModal show={added}>
            <img
              src="https://www.clipartmax.com/png/middle/317-3179395_best-quality-complete-icon.png"
              alt="icon"
            />
            <p>Product added successfully!</p>
          </AddedModal>

          <ShopProfileContainer>
            <ShopProfileImage>
              {/* {shop.coverImage ? (
                <ProfileImage src={shop.coverImage} alt="shop-name" />
              ) : (
                <ProfileImage src={Image} alt="shop-name" />
              )} */}
              {/* <ProfilePicContainer> */}
              {/* {shop.profileImage && shop.profileImage !== "null" ? (
                <ProfilePicContainer src={shop.profileImage} alt="shop-name" />
              ) : (
                <ProfilePicContainer
                  src="https://food-delivery-new.s3.ap-south-1.amazonaws.com/4c4ac7f0-e842-46e3-a82c-bdd7b0074ad7.WEBP"
                  alt="shop-name"
                />
              )} */}
              <ReactImageFallback
                src={shop.profileImage}
                fallbackImage={Image}
                initialImage={Image}
                alt="cool image should be here"
                className="my-shopprofile-image"
              />
              {/* </ProfilePicContainer> */}
              <ShopName>{shop.name}</ShopName>
              <ShopLocation>
                {shop.cityName},{shop.thanaName}
              </ShopLocation>
              <BusinessHour>{shop.bio}</BusinessHour>
              {button}
              <Alert>{alert}</Alert>
            </ShopProfileImage>
            <ShopProfileIntro>
              {/* {shop.coverImage ? (
                <ProfileImage src={shop.coverImage} alt="shop-name" />
              ) : (
                <ProfileImage src={Image} alt="shop-name" />
              )} */}
              <ReactImageFallback
                src={shop.coverImage}
                fallbackImage={Image}
                initialImage={Image}
                alt="cool image should be here"
                className="my-image"
              />
            </ShopProfileIntro>
          </ShopProfileContainer>
          {/* <ShopProfile></ShopProfile> */}
          <ShopNav>
            <NavItem
              to={"/shop/" + props.match.params.shopId}
              exact
              activeStyle={{ color: "green" }}
            >
              {localStorage.catId == "6129e467f8785a2974c9915a"
                ? "Services"
                : "Menu"}
            </NavItem>
            {/* <NavItem to="/shop/reviews" exact activeStyle={{ color: "green" }}>
              Reviews
            </NavItem> */}
          </ShopNav>
          <ShopBody>
            <Route
              path={"/shop/" + props.match.params.shopId}
              //   exact
              //   component={ShopMenu}
              component={() => (
                <ShopMenu
                  showProductHandler={showProductHandler}
                  products={products}
                  shop={shop}
                  isAuthed={true}
                  addToCartHandler={addToCartHandler}
                  searchProducts={searchProducts}
                  filterProducts={filterProducts}
                  activeCat={activeCat}
                  allfilter={Allfilter}
                  searchTextHandler={searchTextHandler}
                  searchText={searchText}
                  loadProducts={loadProducts}
                />
              )}
              // render={(props)=>{
              //     <ShopMenu {...props} products={products} />
              // }}
            />
            <Route path="/shop/reviews" exact component={ShopReviews} />
          </ShopBody>
        </ShopContainer>
      ) : (
        <ShopContainer>
          <Spinner show="true" />
        </ShopContainer>
      )}
      <Footer />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cart: state.utils.cart,
    userId: state.utils.userId,
    shop: state.utils.shop,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCart: (cart) => {
      dispatch({
        type: actionTypes.SET_CART,
        cart,
      });
    },
    setName: (name) => {
      dispatch({
        type: actionTypes.AUTH_USER,
        name,
      });
    },
    setViewedShop: (shop) => {
      dispatch({
        type: actionTypes.SET_VIEWED_SHOP,
        shop,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopView);
